module.exports = __webpack_public_path__ + "media/images/company/company_01_01-5df3de58f5aabd9876db62900d0a2e32.jpg";